'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

type PresentationMode = 'shabad' | 'custom';

interface PresentationModeSwitcherProps {
  defaultMode?: PresentationMode;
  onModeChange?: (mode: PresentationMode) => void;
  className?: string;
}

const PresentationModeSwitcher = ({
  defaultMode = 'shabad',
  onModeChange,
  className = '',
}: PresentationModeSwitcherProps) => {
  const [activeMode, setActiveMode] = useState<PresentationMode>(defaultMode);

  const handleModeChange = (mode: PresentationMode) => {
    setActiveMode(mode);
    onModeChange?.(mode);
  };

  const modes = [
    {
      id: 'shabad' as PresentationMode,
      label: 'Gurbani Shabad',
      icon: 'BookOpenIcon',
      description: 'Present sacred Gurbani text',
    },
    {
      id: 'custom' as PresentationMode,
      label: 'Custom Slides',
      icon: 'PresentationChartBarIcon',
      description: 'Create and manage custom slides',
    },
  ];

  return (
    <div data-component-id="src/components/common/PresentationModeSwitcher.tsx:42:4" data-component-path="src/components/common/PresentationModeSwitcher.tsx" data-component-line="42" data-component-end-line="63" data-component-file="PresentationModeSwitcher.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" className={`flex items-center gap-2 p-1 bg-background rounded-lg border border-border ${className}`}>
      {modes.map((mode) => (
        <button data-component-id="src/components/common/PresentationModeSwitcher.tsx:44:8" data-component-path="src/components/common/PresentationModeSwitcher.tsx" data-component-line="44" data-component-end-line="61" data-component-file="PresentationModeSwitcher.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
          key={mode.id}
          onClick={() => handleModeChange(mode.id)}
          className={`
            flex items-center gap-2 px-4 py-2.5 rounded-md
            transition-smooth font-medium text-sm
            ${
              activeMode === mode.id
                ? 'bg-primary text-primary-foreground shadow-elevated scale-100'
                : 'text-text-secondary hover:text-foreground hover:bg-muted active:scale-[0.98]'
            }
          `}
          aria-pressed={activeMode === mode.id}
          aria-label={mode.description}
        >
          <Icon data-component-id="src/components/common/PresentationModeSwitcher.tsx:59:10" data-component-path="src/components/common/PresentationModeSwitcher.tsx" data-component-line="59" data-component-end-line="59" data-component-file="PresentationModeSwitcher.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={mode.icon as any} size={20} />
          <span data-component-id="src/components/common/PresentationModeSwitcher.tsx:60:10" data-component-path="src/components/common/PresentationModeSwitcher.tsx" data-component-line="60" data-component-end-line="60" data-component-file="PresentationModeSwitcher.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22hidden%20sm%3Ainline%22%7D" className="hidden sm:inline">{mode.label}</span>
        </button>
      ))}
    </div>
  );
};

export default PresentationModeSwitcher;